import React from 'react'
import { Button } from '@mui/material'
import { AddOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import { isMobileView } from 'lib/GlobalConstants'

type Props = {
  handleAddFilterClick: (event: React.MouseEvent<HTMLElement>) => void
}

const AddFilterButton = (props: Props) => {
  const { t } = useTranslation()

  const { handleAddFilterClick } = props
  return (
    <Button
      id="addFilter"
      onClick={handleAddFilterClick}
      size={isMobileView ? 'small' : 'large'}
      sx={{ marginRight: '0.5rem' }}
      startIcon={<AddOutlined />}
    >
      {t('filters.label')}
    </Button>
  )
}

export default AddFilterButton
